import { useState } from 'react';
import { WellsFargoSettingsApi } from '@/api/clients/wells-fargo-settings/wells-fargo-settings.api';

export const useTestWellsFargoApiCredential = (organizationId) => {
  const [testing, setTesting] = useState(false);
  const [testResult, setTestResult] = useState(null);

  const testCredential = async () => {
    setTesting(true);
    setTestResult(null);

    try {
      const response = await WellsFargoSettingsApi.testApiCredential(
        organizationId,
      );
      setTestResult(response.data);
    } finally {
      setTesting(false);
    }
  };

  const clearTestResult = () => setTestResult(null);

  return { testing, testResult, testCredential, clearTestResult };
};
